import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store/index';
import getEncPublicDesignId from 'store/product/selector/getEncPublicDesignId';
import mapPricesToPricesToFetch from 'utils/price/mapPricesToPricesToFetch';
import getPrices from '../selector/getPrices';
import { setPricesToFetchAction } from '../slice';
import fetchPricesOperation from './fetchPricesOperation';

const refetchPricesOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const prices = getPrices(store);
    const encPublicDesignId = getEncPublicDesignId(store);
    if (Object.keys(prices).length === 0) {
      return;
    }
    const pricesToFetch = mapPricesToPricesToFetch(prices, encPublicDesignId);
    dispatch(setPricesToFetchAction(pricesToFetch));
    dispatch(fetchPricesOperation());
  };

export default refetchPricesOperation;
